export var convertValueToOption = function (value, options) {
    // Handle case where value is a single string
    return options.find(function (option) { return option.value === value; });
};
